<template>
    <button @click="printReceipt()" class="btn btn-blue">{{ t('printReceipt') }}</button>
</template>

<script setup>
import { onMounted, onBeforeUnmount } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import eventBus from '@/eventBus';
import { useI18n } from 'vue-i18n';
import html2pdf from 'html2pdf.js';

const router = useRouter();
const route = useRoute();
const { t } = useI18n();

const getReceiptName = () => {
    const now = new Date();
    const pad = n => n.toString().padStart(2, '0');
    const timestamp = `${pad(now.getDate())}${pad(now.getMonth() + 1)}${now.getFullYear()}${pad(now.getHours())}${pad(now.getMinutes())}`;
    return `dodocafe-${timestamp}`;
};

const printReceipt = async () => {
    // Navigate to /receipt if not already there
    if (route.path !== '/receipt') {
        await router.push('/receipt');
    }

    // Wait for the page and content to render
    setTimeout(() => {
        const element = document.getElementById('receipt');
        if (!element) {
            console.error('Receipt element not found.');
            return;
        }

        const options = {
            margin: 10,
            filename: getReceiptName(),
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
        };

        html2pdf().set(options).from(element).save().then(() => {
            // After PDF is saved, go back and click checkout again
            router.push('/');
        });
    }, 300); // Adjust delay if content loads slower
};

// Listen for print reciept event and download the receipt automatically
onMounted(() => {
    eventBus.on('printReceipt', printReceipt);
});

onBeforeUnmount(() => {
    eventBus.off('printReceipt', printReceipt);
});
</script>